export default __webpack_public_path__ + "static/media/social-3.5e663bbd.png";